import { baseApi } from './baseApi';
import { normalizeUser } from '../../utils/normalizeUser';

export const profileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfile: builder.query({
      query: () => '/Auth/get-profile',
      providesTags: ['Profile'],
    }),

    getUserProfile: builder.query({
      query: (queryValue) => ({
        url: '/Auth/GetProfileByNameOrID',
        params: { query: queryValue },
      }),
      transformResponse: (response) => {
        if (!response) return null;

        if (!Array.isArray(response) && !response.$values) {
          return normalizeUser(response);
        }

        const users = response.$values || response;
        return users.length ? normalizeUser(users[0]) : null;
      },
      providesTags: (result, error, queryValue) => [
        { type: 'UserProfile', id: queryValue },
      ],
    }),

    deleteMedia: builder.mutation({
  query: (type) => ({
    url: `/Auth/delete-media?type=${type}`,
    method: 'DELETE',
  }),
  invalidatesTags: ['Profile'],
}),

    editProfile: builder.mutation({
      query: (formData) => ({
        url: '/Auth/edit-profile',
        method: 'PUT',
        body: formData,
      }),
      // Invalidate cache after successful edit
      invalidatesTags: ['Profile', 'UserProfile'],
    }),

    partialEditProfile: builder.mutation({
      query: (formData) => ({
        url: '/Auth/partial-editprofile',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Profile', 'UserProfile'],
    }),
  }),
});

export const {
  useGetProfileQuery,
  useGetUserProfileQuery,
  useLazyGetUserProfileQuery,
  useEditProfileMutation,
  usePartialEditProfileMutation,
  useDeleteMediaMutation,
} = profileApi;